<template>
  <b-modal @hide="hide" id="price-list-excel-modal" :title="$t('insert.PriceList.uploadExcel')" size="lg" hide-footer no-close-on-backdrop>
    <div class="container">
      <b-row>
        <template>
          <input type="file">
        </template>
      </b-row>
      <b-row class="mt-3">
        <div class="w-100 text-right">
          <b-button
            variant="danger"
            size="sm"
            @click="closeModal()"
          >
            {{$t('index.close')}}
          </b-button>
          <b-button
            :disabled="isLoading"
            variant="primary"
            size="sm"
            @click="submitFile()"
          >
            <span v-if="isLoading"><b-spinner small></b-spinner> {{$t('index.loading')}}</span>
            <span v-else>{{$t('index.upload')}}</span>
          </b-button>
        </div>
      </b-row>
      <b-row v-if="datas.length > 0" class="mt-3">
        <b-table-simple hover small caption-top responsive>
          <b-thead>
            <b-tr>
              <b-th>{{$t('index.row')}}</b-th>
              <b-th>{{$t('index.column')}}</b-th>
              <b-th>{{$t('index.message')}}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(data, i) in datas" :key="i">
              <b-td>{{data.key}}</b-td>
              <b-td>{{data.Column}}</b-td>
              <b-td>{{data.Message}}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
// import { required } from 'vuelidate/lib/validators'
import { mapState } from 'vuex'
import * as XLSX from "xlsx";

import mixin from '../../mixins/index'
export default {
  name: 'PriceListExcelModal',
  mixins: [mixin],
  components: {
  },
  computed: {
    ...mapState([''])
  },
  props: {
    modalAction: {
      type: Object,
      default: () => {},
      description: 'Sayfadan seçilen action bilgisi'
    }
  },
  data () {
    return {
      files: null,
      datas: [],
      isError: false,
      isLoading: false
    }
  },
  validations () {
    return {
    }
  },
  methods: {
    hide () {
      this.datas = []
      this.files = null
    },
    submitFile () {
      var file = document.querySelector('input[type="file"]').files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;

        if (data) {
          const binary = new Uint8Array(new Uint8Array(data)).reduce(
            (acc, byte) => acc + String.fromCharCode(byte),
            ""
          );
          const workbook = XLSX.read(binary, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(sheet);
          if(jsonData.length > 0) {
            this.$emit('update', jsonData)
          }
        } 
      };
      reader.onerror = (err) => {
        console.error("File reading failed:", err);
      };
      reader.readAsArrayBuffer(file);
    },
    sendFile (file) {
      let formData = {
        files: file,
        ExcelIntegrationType: 6
      }
      this.isLoading = true
      this.$store.dispatch('importExcel', formData).then(res => {
        this.isLoading = false
        if (res.data.IsCompleted === true) {
          for (const property in res.data.Data) {
            let item = res.data.Data[property]
            if (item.ValidationMessage.length > 0) {
              this.isError = true
              item.ValidationMessage.map(msg => {
                this.datas.push({
                  key: property,
                  Message: msg.Message,
                  Column: msg.Column
                })
              })
            }
          }
          if (!this.isError) {
            document.querySelector('input[type="file"]').value = ''
            this.$emit('update', res.data.Data)
          }
        } else {
          this.$toasted.show(res.Message, {
            type: 'error',
            keepOnHover: true,
            duration: '3000'
          })
        }
      })
    },
    getBase64 (file) {
      let vm = this
      var reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = function () {
        let splitedFile = reader.result.split(',')[1]
        vm.sendFile(splitedFile)
      }
    },
    closeModal () {
      this.$root.$emit('bv::hide::modal', 'price-list-excel-modal')
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Actions/PriceListExcelModal.vue